// Shared helper for the album-experience flow.
// enterAlbumExperience(): smooth-scroll to the Explore the Album intro and
// dispatch an event that tells the master accordion to open. Individual
// chapter drawers remain closed until the visitor deliberately opens them.
// Used by: Hero "Explore the Album" button, Welcome popup CTA, /album route.
export function enterAlbumExperience() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent("open-experience"));
  requestAnimationFrame(() => {
    const el = document.getElementById("experience");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  });
}

// Scroll to a section by id with smooth behavior.
export function scrollToSection(id) {
  if (typeof window === "undefined") return;
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}
